<template>
  <div class="page-list" v-if="pageCount > 0">
    <el-row>
      <el-col :span="12" v-if="showLimit">
        <el-form label-width="auto">
          <el-form-item label="每页显示数量：">
            <el-select
              v-model="pageNumLimit"
              placeholder="请选择"
              size="mini"
              @change="changePageNumLimit"
            >
              <el-option
                v-for="item in pageNums"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="showLimit ? 12 : 24">
        <el-pagination
          :background="background"
          layout="total,prev, pager, next"
          :total="pageCount"
          :page-size="pageLimit"
          @current-change="currentChange"
          :current-page="pageNum"
          v-if="pageCount > 0"
        >
        </el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: {
    pageNum: {
      type: Number,
    },
    pageLimit: {
      type: Number,
    },
    pageCount: {
      type: Number,
    },
    background: {
      type: Boolean,
    },
    showLimit: {
      type: Boolean,
    },
  },
  data() {
    return {
      pageNumLimit: this.pageLimit,
      pageNums: [
        { value: 10, label: "10" },
        { value: 20, label: "20" },
        {
          value: 30,
          label: "30",
        },
      ],
    };
  },
  methods: {
    changePageNumLimit() {
      this.currentChange(this.pageNum);
    },
    currentChange(data) {
      let dataTo = {
        pageNumNow: data,
        pageNumLimit: this.pageNumLimit,
      };
      this.$emit("pageNumNow", dataTo);
    },
  },
};
</script>

<style lang="scss" scoped>
.page-list {
  width: 100%;
  overflow: hidden;
  padding: 2vmin 0;
  .el-select {
    float: left;
    width: 70px;
  }
  .el-pagination {
    float: right;
    margin-right: -10px;
  }
}
</style>
